/**
 * LeaveDocumentTypeService
 * Service for LeaveDocumentType entity operations
 * Route: api/leavedocumenttypes
 */
import { CrudService } from '../base/CrudService';
/**
 * LeaveDocumentTypeService
 * Handles leave document type CRUD operations
 */
export class LeaveDocumentTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaveDocumentTypeService.DEFAULT_SERVICE_PATH,
            basePath: LeaveDocumentTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaveDocumentTypeService.DEFAULT_SERVICE_PATH = 'hr';
LeaveDocumentTypeService.BASE_PATH = 'api/leavedocumenttypes';
//# sourceMappingURL=LeaveDocumentTypeService.js.map